import React from 'react';

import './Obfuscate.sass';

function Obfuscate({ children }) {
    return <span className="Obfuscate">{children}</span>;
}

export default Obfuscate;
